import { useCallback } from 'react';

export default function useCanvasManipulation(canvas) {
    const persistMutation = useCallback((target) => {
        if (!canvas || !target) return;
        canvas.requestRenderAll();
        canvas.fire("object:modified", {target});
    }, [canvas]);

    const copyObject = useCallback(() => {
        if (!canvas) return;
        // logique de copie
        const activeObject = canvas.getActiveObject();
        if (activeObject) {
            activeObject.clone((cloned) => {
                canvas._clipboard = cloned; // Stocke l'objet cloné dans le clipboard interne
            });
        }
    }, [canvas]);

    const pasteObject = useCallback(() => {
        if (!canvas || !canvas._clipboard) return;
        // logique de collage
        canvas._clipboard.clone((clonedObj) => {
            canvas.discardActiveObject();
            clonedObj.set({
                left: clonedObj.left + 20, // Décale légèrement l'objet collé
                top: clonedObj.top + 20,
                evented: true,
            });

            if (clonedObj.type === "activeSelection") {
                clonedObj.canvas = canvas;
                clonedObj.forEachObject((obj) => {
                    canvas.add(obj);
                });
                clonedObj.setCoords();
            } else {
                canvas.add(clonedObj);
            }

            canvas.setActiveObject(clonedObj);
            canvas.requestRenderAll();
        });
    }, [canvas]);

    const bringToFront = useCallback(() => {
        if (!canvas) return;
        const target = canvas.getActiveObject();
        canvas.bringToFront(target);
        persistMutation(target);
    }, [canvas, persistMutation]);

    const sendToBack = useCallback(() => {
        if (!canvas) return;
        const target = canvas.getActiveObject();
        canvas.sendToBack(target);
        persistMutation(target);
    }, [canvas, persistMutation]);

    const moveForward = useCallback(() => {
        if (!canvas) return;
        const target = canvas.getActiveObject();
        canvas.bringForward(target);
        persistMutation(target);
    }, [canvas, persistMutation]);

    const moveBackward = useCallback(() => {
        if (!canvas) return;
        const target = canvas.getActiveObject();
        canvas.sendBackwards(target);
        persistMutation(target);
    }, [canvas, persistMutation]);

    return { copyObject, pasteObject, bringToFront, sendToBack, moveForward, moveBackward };
}
